import { render, staticRenderFns } from "./CountryBox.vue?vue&type=template&id=636dacca&scoped=true"
import script from "./CountryBox.vue?vue&type=script&lang=js"
export * from "./CountryBox.vue?vue&type=script&lang=js"
import style0 from "./CountryBox.vue?vue&type=style&index=0&id=636dacca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636dacca",
  null
  
)

export default component.exports